import { useEffect, useState } from 'react';
import { useProductDispatch, useProductPageStatus, useProductState } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import gtm from '@/utils/gtm';

const A: React.FC = () => {
    const { t } = useLang('dpux');
    const [enter, setEnter] = useState(false);
    const pageStatus = useProductPageStatus();
    const { locale = 'us' } = getLocal();
    const { productMsg } = useProductState();
    const dispatch = useProductDispatch();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const st = setTimeout(() => {
                setEnter(true);
            }, 1000);
            return () => {
                clearTimeout(st);
            };
        }
    }, []);

    const handleShop = () => {
        window.open(productMsg?.buyLink || `https://${locale}.ecoflow.com/products/delta-pro-ultra-x`);
        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: 'EcoFlow DELTA Pro Ultra X_KV',
            position: 'Product Preview',
            __btn_id1: `delta-pro-ultra-x-A .btn-shop`,
            __btn_id2: 'btn-shop',
            __btn_type: 'common',
        });
    };
    const handleFreeQuote = () => {
        dispatch({
            type: 'changeShowFreeQuote',
            payload: true,
        });
        gtm.push({
            event: 'uaEvent',
            event_name: 'floating_button',
            button_name: `${t('FreeQuote.title')}_KV`,

            __btn_id1: `delta-pro-ultra-x-A .btn-freeQuote`,
            __btn_id2: 'btn-freeQuote',
            __btn_type: 'common',
        });
    };

    return (
        <section
            className={`${css.section} ${pageStatus !== IPageStatus.TEASER ? css.zhenshi : ''} dpux-A delta-pro-ultra-x-A GtmModuleData-section`}
            id="delta-pro-ultra-x-A"
            data-section-id={'delta-pro-ultra-x-A'}
            data-section-title={t('A_title')}
        >
            <div className="img">
                <picture className="picture">
                    <source
                        media={`(min-width: 1025px)`}
                        srcSet={
                            pageStatus === IPageStatus.TEASER
                                ? 'https://websiteoss.ecoflow.com/upload/image/1758938945615/pc_kv.webp'
                                : locale === 'us'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1763718142254/PC_KV.webp'
                                : 'https://websiteoss.ecoflow.com/upload/image/1761814678853/PC.webp'
                        }
                        type="image/webp"
                    />
                    <source
                        media={`(max-width: 1024px)`}
                        srcSet={
                            pageStatus === IPageStatus.TEASER
                                ? 'https://websiteoss.ecoflow.com/upload/image/1758938952394/m_kv.webp'
                                : locale === 'us'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1763953739351/M_KV.webp'
                                : 'https://websiteoss.ecoflow.com/upload/image/1761810965280/M.webp'
                        }
                        type="image/webp"
                    />
                    <source
                        media={`(max-width: 1024px)`}
                        srcSet={
                            pageStatus === IPageStatus.TEASER
                                ? 'https://websiteoss.ecoflow.com/upload/image/1758938719395/m_kv.jpg'
                                : locale === 'us'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1763953739136/M_KV.jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1761810965429/M.jpg'
                        }
                    />
                    <img
                        fetchpriority="high"
                        loading="eager"
                        src={
                            pageStatus === IPageStatus.TEASER
                                ? 'https://websiteoss.ecoflow.com/upload/image/1758938719395/m_kv.jpg'
                                : locale === 'us'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1763953739136/M_KV.jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1761810965429/M.jpg'
                        }
                        alt={t('A_title')}
                        width="100%"
                        height="100%"
                    />
                </picture>
            </div>
            <div className={`info ${enter ? 'enter' : ''}`}>
                <div className={`inner`}>
                    <div className={`title ani-1 ${enter ? ' enter' : ''}`}>{t('A_title')}</div>
                    <p className={`desc ani-2 ${enter ? ' enter' : ''}`}>
                        {t.rich('A_desc', {
                            s: (s: string) => <span className="s">{s}</span>,
                        })}
                    </p>
                    {locale === 'us' && (
                        <>
                            <div className={`btns `}>
                                <div className="btn-item btn-shop GtmModuleData-btn-common" data-btn-id="btn-shop" onClick={handleShop}>
                                    {t('A_shop')}
                                </div>
                                <div className="btn-item btn-freeQuote GtmModuleData-btn-common" data-btn-id="btn-freeQuote" onClick={handleFreeQuote}>
                                    {t('A_freeQuote')}
                                </div>
                            </div>
                            <picture className={`ces-img `}>
                                <source srcSet="https://websiteoss.ecoflow.com/upload/image/1763707191564/ces-img.webp" type="image/webp" />
                                <img
                                    fetchpriority="high"
                                    loading="eager"
                                    src="https://websiteoss.ecoflow.com/upload/image/1763707191391/ces-img.png"
                                    width="100%"
                                    height="100%"
                                />
                            </picture>
                        </>
                    )}
                </div>
            </div>
        </section>
    );
};

export default A;
